import React, { useState, useEffect, useRef } from "react";
import Search from "../../components/search/search";
import TeamFilter from "../UI/TeamFilter/teamFilter";
import { withRouter } from "react-router-dom";
import * as Moment from "moment";
import Menu from "../menu/menu";
import anime from "animejs";
// import { da } from "date-fns/locale/da";

// import * as _ from "lodash";

import ActivityMember from "../../components/activityMember/activityMember";
import styled, { css } from "styled-components";

import {
  SwipeableList,
  SwipeableListItem
} from "@sandstreamdev/react-swipeable-list";
import "@sandstreamdev/react-swipeable-list/dist/styles.css";

import InfiniteCalendar from "react-infinite-calendar";
import "react-infinite-calendar/styles.css"; // only needs to be imported once

import { format } from "date-fns";

import { ReactComponent as _KickIcon } from "../../assets/kick.svg";


// Icons
const KickIcon = styled(_KickIcon)`
  width: 18px;
  height: 18px;
  margin-right: 5px;

  color: #ff0;
  fill: currentColor;
  transition: all 200ms;
`;

// Const
const ACT_TRAINING = "NCDFOapeUK5GsU6PHTBo";
const ACT_INSTRUCTOR = "qw0N72HFzjXJeNQAmCk2";

// const colors
const HEADER_BG = "#00224d";
const HEADER_BG_SHADOW = "#000";
const HEADER_TEAMS_BG = "#003271";
const HEADER_TEAMS_BG_SHADOW = "#000";
const HEADER_TEAM_BG = "#003271";
const CAL_TOP_BG = "#003271";
const CAL_YEAR_BORDER = "#003271";
const CAL_BOTTOM_BG = "#003271";
const CAL_DAY_SELECTION_BG = "#003271";

const ActivityTypeStyles = {
  [ACT_TRAINING]: {
    // background: "#00a4ca",
    background: "#003271",
    color: "white"
  },
  [ACT_INSTRUCTOR]: {
    // background: "#ff0082",
    background: "#ef006e",
    color: "white"
  }
};

// LOCALE FOR INIFINITE CALENDAR

const locale = {
  blank: "Vælg en dag",
  headerFormat: "DD. MMM",
  locale: require("date-fns/locale/da"), // You need to pass in the date-fns locale for the language you want (unless it's EN)
  todayLabel: {
    long: "i dag",
    short: "i dag"
  },
  weekdays: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
  months: [
    "januar",
    "februar",
    "marts",
    "april",
    "maj",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "december"
  ],
  weekStartsOn: 1 // Start the week on Monday
};

// ************************************************************************************
// STYLES
// ************************************************************************************
const Loader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 1 auto;

  img {
    margin-top: -150px;
    margin-bottom: 20px;
    flex: 0 0 auto;
    width: 72px;
  }
`;

const ActivityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  margin: 0;
  height: 100%;
`;

const ActivityContent = styled.div`
  display: flex;
  flex-direction: column;

  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  height: 100%;
  flex: 1 1 auto;
  overflow: auto;
`;

// Parent to StyledSvipeableList
const MemberListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  /* margin-bottom: 100px; */
  div:first-child {
    overflow-y: unset;
  }

  .bottom {
    flex: 0 0 800px;
    background: #003271;
  }
`;

const InfiniteCalendarStyled = styled(InfiniteCalendar)`
  .Cal__Header__wrapper {
    display: flex;
    flex-grow: 1;
    cursor: pointer;
    flex-direction: row !important;
  }

  .Cal__Header__root {
    background: #003271 !important;
    /* padding: 4px 20px 4px 20px !important; */
    padding: 0 !important;
    min-height: 10px;
  }

  .Cal__Header__dateWrapper.Cal__Header__year {
    background: ${CAL_TOP_BG} !important;
    /* height: 20px; */
    font-size: 18px;
    line-height: 36px;
    flex: 0 0 80px;
    padding: 10px;
    text-align: center;
    align-self: center;
    justify-content: center;
    border-right: 3px solid ${CAL_YEAR_BORDER};
  }

  .Cal__Header__dateWrapper.Cal__Header__day {
    /* height: 22px; */
    font-size: 20px;
    line-height: 36px;
    text-transform: capitalize;
    flex: 1 1 auto;
    margin-left: 20px;
  }

  .Cal__Container__wrapper {
    .Cal__Weekdays__root {
      background: #003271 !important;
      .Cal__Weekdays__day {
        padding: 0;
      }
    }
  }

  .Cal__Day__selection {
    background: ${CAL_DAY_SELECTION_BG} !important;
  }
`;

const SwipeableContent = styled.div`
  display: flex;
  flex: 1 1 auto;
  height: 100%;
  /* min-height: 60px; */
  box-shadow: 0px 1px 4px 0px #ffffff, inset 0px 0px 70px -20px #999;

  ${({ activityTypeId }) =>
    activityTypeId && css(ActivityTypeStyles[activityTypeId])};

  ${({ flexRight }) =>
    flexRight &&
    css`
      justify-content: flex-end;
    `}

  div {
    align-self: right;
    padding: 10px;
    background: rgba(0, 0, 0, 0.1);
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 101px;
  /* min-height: 50px; */
`;

const HeaderWrapper = styled.div`
  /* .members-page .members-header-wrapper  */
  background: ${HEADER_TEAMS_BG};
  box-shadow: inset 0px 0px 4px -1px ${HEADER_TEAMS_BG_SHADOW};

  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  h3 {
    color: white;
    margin: 0;
    /* flex: 0 1 auto; */
    font-size: 0.8em;
    padding-left: 10px;
  }
`;

const MembersHeaderTop = styled.div`
  background: ${HEADER_BG};
  flex: 1 0 auto;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px;

  img {
    flex: 0 0 34px;
    margin-left: 40px;
    height: 32px;
  }

  .header-title {
    flex: 1 1 auto;
    padding: 0 6px 0 6px;
    margin: 0;
  }
`;

const HeaderBottom = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1 0 auto;
`;

const ActivityCount = styled.div`
  flex: 0 0 45px;
  padding: 8px;
  color: white;
  display: flex;
  flex-direction: column;
  text-align: center;
  cursor: pointer;

  ${({ selected }) =>
    selected &&
    css`
      background: rgba(0, 0, 0, 0.3);
      box-shadow: inset 0px 0px 30px 0px rgba(0, 0, 0, 0.3);
    `};

  .title {
    font-size: 0.6em;
  }
  .value {
  }
`;

Moment.updateLocale("en", {
  relativeTime: {
    future: "om %s",
    past: "%s siden",
    s: "få sekunder",
    ss: "%d sekunder",
    m: "ét minut",
    mm: "%d minutter",
    h: "en time",
    hh: "%d timer",
    d: "en dag",
    dd: "%d dage",
    M: "et måned",
    MM: "%d måneder",
    y: "et år",
    yy: "%d år"
  },
  months: [
    "Januar",
    "Februar",
    "Marts",
    "April",
    "Maj",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "December"
  ],
  monthsShort: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Maj",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dec"
  ]
});

// ***************************************************************************
//
// Activities
//
// ***************************************************************************
const Activities = props => {
  // Render the Calendar
  const [activityDate, setActivityDate] = useState();
  const [filteredMembers, setFilteredMembers] = useState([]);
  const [forceReload, setForceReload] = useState(false);

  const [activeMembersCount, setActiveMembersCount] = useState();

  const [searchHasFocus, setSearchHasFocus] = useState(false);

  const [showActiveOnly, setShowActiveOnly] = useState(false);
  const infiniteCalendarStyledRef = useRef(null);

  const activityWrapperRef = useRef(null);
  const activityContentRef = useRef(null);
  const memberListWrapperRef = useRef(null);
  const membersHeaderTopRef = useRef(null);
  const headerWrapperRef = useRef(null);
  const swipeRef = useRef({});

  useEffect(() => {
    // setActivityDate(format(new Date("2019-12-18"), 'yyy-MM-dd'))
    setActivityDate(format(new Date(), "yyy-MM-dd"));

    if (props.firebaseReady && (!props.membersLoaded || forceReload)) {
      props.loadMembers();
      setForceReload(false);
    }

    props.updateFilteredMembers(props.searchValue, props.teamId, props.status);

    console.log("SwipeREF------------------:", swipeRef);
  }, []);

  // If filter changes then move all activities to the bottom
  useEffect(() => {
    const membersWithActivities = [];
    const membersWithout = [];

    props.filteredMembers.forEach(member => {
      if (
        member.Activities &&
        member.Activities.find(act => act.Date == activityDate)
      ) {
        membersWithActivities.push(member);
      } else {
        membersWithout.push(member);
      }
    });

    setActiveMembersCount(membersWithActivities.length);
    setFilteredMembers(
      showActiveOnly ? [...membersWithActivities] : [...props.filteredMembers]
      // : [...membersWithout, ...membersWithActivities]
    );
  }, [
    props.filteredMembers,
    activityDate,
    props.membersLoaded,
    showActiveOnly
  ]);

  useEffect(() => {
    console.log("EFFECT >> Activities-----------------update members");
    // if (props.firebaseReady && (!props.membersLoaded || forceReload)) {
    //   props.loadMembers();
    //   setForceReload(false);
    // }

    // // clean refs
    // swipeRef.current = Object.keys(swipeRef.current).filter(key => swipeRef.current[key] != null)
    // console.log("swipeRef.current: ", swipeRef.current)

    // props.updateFilteredMembers(props.searchValue, props.teamId, props.status);
  }, [
    props.firebaseReady,
    props.membersLoaded,
    props.searchValue,
    props.teamId,
    props.status,
    forceReload
  ]);

  useEffect(() => {
    // console.log("EFFEECT----------------------searchHasFocus:", searchHasFocus);
    // console.log(
    // "EFFEECT----------------------infiniteCalendarStyledRef:",
    // infiniteCalendarStyledRef
    // );
    // console.log(
    // "EFFEECT----------------------infiniteCalendarStyledRef.current:",
    // infiniteCalendarStyledRef.current
    // );

    if (searchHasFocus) {
      // hide the calendar
      anime({
        targets: infiniteCalendarStyledRef.current,
        // translateY: -500,
        marginTop: infiniteCalendarStyledRef.current.clientHeight * -1,
        easing: "easeOutCubic",
        duration: 500
      });
    } else {
      anime({
        targets: infiniteCalendarStyledRef.current,
        // translateY: -0,
        marginTop: 0,
        easing: "easeOutCubic",
        duration: 500
      });
    }
  }, [searchHasFocus]);

  // ************************************************************************

  // ***************************************************************************
  const scrollToTop = ref => {
    // works
    ref.listElement.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });

    // memberListWrapperRef.current.scrollIntoView({
    //   behavior: "smooth",
    //   block: "start"
    // })
  };

  const scrollOutLeft = ref => {
    // anime({
    //   targets: ref.listElement,
    //   translateX: (ref.listElement.clientWidth + 100) * -1
    // });
  };

  // const scrollOutRight = ref => {
  //   anime({
  //     targets: ref.listElement,
  //     translateX: ref.listElement.clientWidth + 100
  //   });
  // };

  const handleSelectDate = date => {
    setActivityDate(format(date, "yyyy-MM-dd"));
  };

  const handleUpdateMemberActivity = (ActivityTypeId, date, member) => {
    let newActivity = null;

    // Change the activity with new activity id if the id is null
    // then remove any activity for selected date.
    if (ActivityTypeId !== null) {
      const foundActivityType = props.activityTypes.find(
        act => act.ID == ActivityTypeId
      );
      console.log("foundActivityType: ", foundActivityType);

      if (!foundActivityType) {
        return false;
      }

      const inst =
        props.currentlyLoggedInUser &&
        props.currentlyLoggedInUser.uidProfile &&
        props.currentlyLoggedInUser.uidProfile.Name;

      // Prepare the activity
      newActivity = {
        ActivityTypeId: ActivityTypeId,
        Date: date,
        Name: foundActivityType.Name,
        Score: foundActivityType.Score,
        Instructor: inst
      };
    }

    // Get previous activities for this member
    const memberActivities = member.Activities ? [...member.Activities] : [];

    // remove any "old" matching activity
    let filteredMemberActivities = memberActivities.filter(
      act => act.Date !== date
    );

    // Add the new activity - only add newActivity if it is not null
    filteredMemberActivities =
      newActivity != null
        ? [...filteredMemberActivities, newActivity]
        : [...filteredMemberActivities];

    // create new member collection
    const updatedMember = {
      ...member,
      Activities: [...filteredMemberActivities]
    };

    props.updateMember(member.ID, updatedMember, false);
    // setForceReload(true);
  };

  const memberHeader = (
    <HeaderWrapper status={props.status} ref={headerWrapperRef}>
      <MembersHeaderTop
        ref={membersHeaderTopRef}
        onClick={() => scrollToTop(swipeRef.current[0])}
      >
        <img src="/icons/apple-icon-72x72.png" alt="icon" />
        <div className="header-title">
          <h3>{props.status == "ny" && "Nye "}Aktiviteter</h3>
          <h3 style={{ color: "yellow" }}>
            {props.foundNewMembersCount > 0 && <><KickIcon />{props.foundNewMembersCount}</>}
          </h3>
        </div>
        <Search
          hasFocus={focus => setSearchHasFocus(focus)}
          searchValue={props.searchValue}
          changed={e => {
            // props.updateFilteredMembers(e.target.value)} />
            const statusId = props.status ? props.status : "any";
            props.history.push(
              "/activities/" +
                props.teamId +
                "/" +
                statusId +
                "/" +
                e.target.value
            );
            props.updateFilteredMembers(
              e.target.value,
              props.teamId,
              props.status
            );
          }}
        />
      </MembersHeaderTop>
      <HeaderBottom>
        <TeamFilter
          page="/activities/"
          forMemberActivities={true}
          searchValue={props.searchValue}
          teamId={props.teamId}
          status={props.status}
          changed={props.updateFilteredMembers}
        />

        <ActivityCount
          selected={showActiveOnly}
          onClick={() => setShowActiveOnly(!showActiveOnly)}
        >
          <div className="title">AKTIVE</div>
          <div className="value">{activeMembersCount}</div>
        </ActivityCount>
      </HeaderBottom>
    </HeaderWrapper>
  );

  let memberRanks = [];

  const membersList = filteredMembers.map((member, idx) => {
    memberRanks = props.ranks.filter(rank => {
      return rank.MemberId == member.ID;
    });

    const currentMemberActivity =
      member.Activities &&
      member.Activities.find(act => act.Date == activityDate);
    // console.log("currentMemberActivity: ", currentMemberActivity)

    const swipeLeft =
      currentMemberActivity &&
      currentMemberActivity.ActivityTypeId == ACT_TRAINING
        ? {
            content: (
              <SwipeableContent flexRight>
                <div>Ikke aktiv</div>
              </SwipeableContent>
            ),
            action: () => {
              console.log("swipe LEFT - ikke aktiv");
              scrollOutLeft(swipeRef.current[idx]);
              handleUpdateMemberActivity(null, activityDate, member);
            }
          }
        : {
            content: (
              <SwipeableContent activityTypeId={ACT_TRAINING} flexRight>
                <div>Træning</div>
              </SwipeableContent>
            ),
            action: () => {
              console.log("swipe LEFT - Træning");
              scrollOutLeft(swipeRef.current[idx]);

              handleUpdateMemberActivity(ACT_TRAINING, activityDate, member);
            }
          };
    const swipeRight =
      currentMemberActivity &&
      currentMemberActivity.ActivityTypeId == ACT_INSTRUCTOR
        ? {
            content: (
              <SwipeableContent>
                <div>Ikke aktiv</div>
              </SwipeableContent>
            ),
            action: () => handleUpdateMemberActivity(null, activityDate, member)
          }
        : {
            content: (
              <SwipeableContent activityTypeId={ACT_INSTRUCTOR}>
                <div>Instruktør</div>
              </SwipeableContent>
            ),
            action: () =>
              handleUpdateMemberActivity(ACT_INSTRUCTOR, activityDate, member)
          };

    return (
      <SwipeableListItem
        ref={ref => (swipeRef.current[idx] = ref)}
        key={member.ID}
        swipeLeft={swipeLeft}
        swipeRight={swipeRight}
      >
        <ActivityMember
          selectedActivityDate={activityDate}
          member={member}
          key={member.ID}
          memberRanks={memberRanks}
        />
      </SwipeableListItem>
    );
  });

  return props.membersLoaded ? (
    <ActivityWrapper ref={activityWrapperRef}>
      <Header>
        <Menu currentlyLoggedInUser={props.currentlyLoggedInUser} />
        {memberHeader}
      </Header>

      <ActivityContent ref={activityContentRef}>
        <div ref={infiniteCalendarStyledRef}>
          <InfiniteCalendarStyled
            locale={locale}
            width="100%"
            height={155}
            selected={activityDate}
            onSelect={date => handleSelectDate(date)}
          />
        </div>

        {/* <Content> */}
        <MemberListWrapper ref={memberListWrapperRef}>
          <SwipeableList>{membersList}</SwipeableList>
          <div className="bottom" />
        </MemberListWrapper>
        {/* </Content> */}
      </ActivityContent>
    </ActivityWrapper>
  ) : (
    <Loader>
      <img src="/icons/apple-icon-72x72.png" alt="logo" />
      Henter data...
    </Loader>
  );
};

export default withRouter(Activities);
